module.exports = __webpack_public_path__ + "def0dfbc654e2d1afdb1023873e08834.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/giant-bow-blue-s.png
// module id = 2820
// module chunks = 0